import { Stack } from 'expo-router';
import { useThemeColors } from 'smoothie';

import LogoIcon from '../../../../assets/images/logos/fruitful-logo-icon-only-white.svg';

export default function OAuthLayout() {
    const { getColor } = useThemeColors();

    return (
        // <RedirectFullyAuthedUser> is not part of this layout and this is excluded since this flow
        // shouldn't push a user into the regular app. Redirects back to Synctera/Plaid after fully logged in
        // (username/password + MFA) are handled inside the relevant components not via useEffect on the user object
        <Stack
            screenOptions={{
                headerShown: true,
                headerLeft: () => null, // Prevents back button from showing
                headerStyle: {
                    backgroundColor: getColor('$green1100'),
                },
                headerTitle: () => <LogoIcon height={20} />,
                headerTitleAlign: 'center',
                contentStyle: {
                    backgroundColor: getColor('$white'),
                },
            }}
        />
    );
}
